export default [
  {
    path: "/referral",
    name: "internReferralView",
    meta: { hideBottomNavigation: true, hideAppBar: true, fullWidth: true },
    component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/leads/internReferralView.vue"),
  },
  {
    path: "/l/:link",
    name: "PublicLeads",
    component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/leads/public/LeadView.vue"),
    meta: { hideBottomNavigation: true, hideAppBar: true, fullWidth: true },
  },
  {
    path: "/danke",
    name: "thankyou",
    component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/leads/public/ThankYou.vue"),
    meta: { hideBottomNavigation: true, hideAppBar: true, fullWidth: true },
  },
  {
    path: "/r/:email",
    name: "ReferralView",
    meta: { hideBottomNavigation: true, hideAppBar: true, fullWidth: true },
    component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/leads/public/ReferralView.vue"),
  },
]
